import dayjs from "dayjs";

const CARE_TEAM_PHONE_NUMBER = "+1781-650-4492";

export const calculateAge = (dob) => {
    const today = dayjs();
    const birthDate = dayjs(dob);

    const years = today.diff(birthDate, 'year');
    const birthDatePlusYears = birthDate.add(years, 'year');
    const extraDays = today.diff(birthDatePlusYears, 'day');

    const age = years + extraDays / 365.25;
    return age;
};

export const handleContactCareTeam = () => {
    window.location.href = `sms:${CARE_TEAM_PHONE_NUMBER}`;
};